import React from 'react';
import {
  Box, Button, Stack, Typography, styled,
} from '@worthy-npm/worthy-common-ui-components';

const ErrorStateContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

interface ErrorStateProps {
  message: string;
  buttonText?: string;
  onButtonClick?: () => void;
  onRetry?: () => void;
}

export default function ErrorState({
  message,
  buttonText,
  onButtonClick,
  onRetry,
}: ErrorStateProps) {
  const hasRetry = !!onRetry;
  const hasButtonClick = !!onButtonClick;

  return (
    <ErrorStateContainer>
      <Stack gap={2} alignItems="center" width="100%" maxWidth="562px">
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: 'text.primary',
            height: '42px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {message}
        </Typography>
        {hasRetry && (
          <Button
            variant="contained"
            onClick={onRetry}
            disableElevation
            sx={{
              backgroundColor: 'text.primary',
              color: 'background.paper',
              '&:hover': {
                backgroundColor: 'text.primary',
              },
            }}
          >
            Try again
          </Button>
        )}
        {hasButtonClick && hasRetry && (
          <Typography
            sx={{
              textAlign: 'center',
              color: 'secondary.main',
            }}
          >
            or
          </Typography>
        )}
        {hasButtonClick && (
          <Button
            variant="contained"
            onClick={onButtonClick}
            disableElevation
            sx={{
              backgroundColor: 'text.primary',
              color: 'background.paper',
              '&:hover': {
                backgroundColor: 'text.primary',
              },
            }}
          >
            {buttonText}
          </Button>
        )}
      </Stack>
    </ErrorStateContainer>
  );
}
